.layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 1px;
  height: 1px;
  overflow: visible;
  pointer-events: none;
  z-index: 0;
}

.layer marker path {
  fill: var(--ink-soft);
}

.selectedMarker {
  fill: var(--focus) !important;
}

.blockMarker {
  fill: none !important;
  stroke: #9a3b2e;
  stroke-width: 2;
}

.line {
  stroke: var(--ink-soft);
  stroke-width: 1.5;
  fill: none;
  vector-effect: non-scaling-stroke;
}

.layer g[data-type='blocks'] .line {
  stroke: #9a3b2e;
}

.layer g[data-type='contains'] .line {
  stroke-width: 2.5;
}

.layer g[data-selected='true'] .line {
  stroke: var(--focus);
  stroke-width: 2.5;
}

.label {
  font-size: 11px;
  font-family: var(--font-mono);
  fill: var(--ink-faint);
  paint-order: stroke;
  stroke: var(--field);
  stroke-width: 3px;
}

.layer g[data-selected='true'] .label {
  fill: var(--focus);
}
